import React from "react";

//UI Material
import { Box } from "@mui/material";

//React-chartjs-2
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartsJS,
  CategoryScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
} from "chart.js";

//Helpers
import { getFilteredTOrdersByDateRangeFromLocalTimeStrings } from "../../Helpers/orderFunctions";

ChartsJS.register(
  CategoryScale,
  PointElement,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const targetProducts = [
  "Adaptador Tipo 1 a Tipo 2",
  "Adaptador CCS1 a CCS2",
  "Adaptador Tipo 2 a Tipo 1",
  "Adaptador Tipo 1 a GB/T",
  "Simulador de Estación",
  "Extensión VTOL",
  "Adaptador ChaDeMO a GB/T",
  "Probador de Estaciones",
  "Convertidor VTOL",
  "Kit de pared",
];

export default function AccesoriesGraph({ data = [], year }) {
  const extractedInfo = getFilteredTOrdersByDateRangeFromLocalTimeStrings(
    data.filter((order) => targetProducts.includes(order.productName)),
    `1/1/${year}`,
    `12/31/${year}`
  );

  //Function to generate graph datasets
  const generateDataSets = () => {
    let products = [
      {
        label: "Simulador de Estación",
        data: new Array(12).fill(0),
        backgroundColor: "#000000",
        borderColor: "#000000",
        pointRadius: 1,
        tension: 0.2,
      },
      {
        label: "Adaptador Tipo 1 a Tipo 2",
        data: new Array(12).fill(0),
        backgroundColor: "#001214",
        borderColor: "#001214",
        pointRadius: 1,
        tension: 0.2,
      },
      {
        label: "Adaptador Tipo 1 a GB/T",
        data: new Array(12).fill(0),
        backgroundColor: "#002529",
        borderColor: "#002529",
        pointRadius: 1,
        tension: 0.2,
      },
      {
        label: "Adaptador CCS1 a CCS2",
        data: new Array(12).fill(0),
        backgroundColor: "#00363E",
        borderColor: "#00363E",
        pointRadius: 1,
        tension: 0.2,
      },
      {
        label: "Adaptador Tipo 2 a Tipo 1",
        data: new Array(12).fill(0),
        backgroundColor: "#005B67",
        borderColor: "#005B67",
        pointRadius: 1,
        tension: 0.2,
      },
      {
        label: "Adaptador ChaDeMO a GB/T",
        data: new Array(12).fill(0),
        backgroundColor: "#00808F",
        borderColor: "#00808F",
        pointRadius: 1,
        tension: 0.2,
      },
      {
        label: "Extensión VTOL",
        data: new Array(12).fill(0),
        backgroundColor: "#0091A5",
        borderColor: "#0091A5",
        pointRadius: 1,
        tension: 0.2,
      },
      {
        label: "Probador de Estaciones",
        data: new Array(12).fill(0),
        backgroundColor: "#00A4B9",
        borderColor: "#00A4B9",
        pointRadius: 1,
        tension: 0.2,
      },
      {
        label: "Convertidor VTOL",
        data: new Array(12).fill(0),
        backgroundColor: "#00A4B9",
        borderColor: "#00A4B9",
        pointRadius: 1,
        tension: 0.2,
      },
      {
        label: "Kit de pared",
        data: new Array(12).fill(0),
        backgroundColor: "#00A4B9",
        borderColor: "#00A4B9",
        pointRadius: 1,
        tension: 0.2,
      },
    ];

    //Fill order objects iterating trough orders
    for (const { productsStatus, productName } of extractedInfo) {
      for (const product of productsStatus) {
        try {
          const month = new Date(product.finishedAt).getMonth();
          //Validate month
          if (!isNaN(Number(month))) {
            const targetOrder = products.find(
              (product) => product.label === productName
            );

            targetOrder.data[month] += 1;
          }
        } catch (e) {
          console.log(e);
        }
      }
    }

    return products;
  };

  //Function to generate chart data
  const generateChartData = () => ({
    datasets: generateDataSets(),
    labels: [
      "Ene",
      "Feb",
      "Mar",
      "Abr",
      "May",
      "Jun",
      "Jul",
      "Ago",
      "Set",
      "Oct",
      "Nov",
      "Dic",
    ],
  });
  //Function to generate chart options
  const generateChartOptions = () => ({
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: { beginAtZero: true },
    },
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 15,
        },
      },
      title: {
        display: true,
        text: `Accesorios producidos (Finalizados) para cada mes del año`,
      },
    },
  });

  // ==========>Component<==========
  return (
    <Box sx={{ minHeight: "250px" }}>
      <Bar options={generateChartOptions()} data={generateChartData()} />
    </Box>
  );
}
